import { Component, Emit, Model, Prop, Vue } from 'vue-property-decorator';
import GoModal from '@/core/go-modal/go-modal.vue';

@Component({
  components: {
    'go-modal': GoModal,
  },
})
export default class ChannelResultsModal extends Vue {
  @Model('open', { type: Boolean, required: true }) open!: boolean;
  @Prop({ type: String }) readonly type: 'SUCCESS' | 'ERROR' | null = null;
  @Prop({ type: String }) readonly title: string;
  @Prop({ type: String }) readonly description: string;

  @Emit('modal:close') close() {}
}
